export default () => ({
  user: false,
  apiKeys: [],
  totalRows: 0,
  iphoneFix: false,
});
